import { render, staticRenderFns } from "./ImageCollage.html?vue&type=template&id=91bcd3e2&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./ImageCollage.scss?vue&type=style&index=0&id=91bcd3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bcd3e2",
  null
  
)

export default component.exports